import { useFormContext } from 'react-hook-form';
import {
  ConnectedAutoFillCustomersButton,
  ConnectedAutoFillMe,
  ConnectedAutoFillVendorsButton,
} from '../auto-fill-contacts';
import { InvoiceManagementInvoiceFormType } from '../forms/invoice/types';
import { InvoiceManagementInvoiceForm } from './InvoiceManagementInvoiceForm';

type InvoiceFormProps = {
  readonly?: boolean;
  onSubmit: (data: InvoiceManagementInvoiceFormType) => void;
  formId?: string;
};

export const InvoiceManagementConnectedInvoiceForm = ({ readonly, onSubmit, formId }: InvoiceFormProps) => {
  const contextMethods = useFormContext<InvoiceManagementInvoiceFormType>();

  const selectedCurrency = contextMethods.watch('currency');

  if (!contextMethods) {
    throw new Error(
      'Using `ConnectedInvoiceForm` is allowed only inside react-hook-form context. Place `ConnectedInvoiceForm` as child of `FormProvider`',
    );
  }

  return (
    <InvoiceManagementInvoiceForm
      formId={formId}
      readonly={readonly}
      control={contextMethods.control}
      setValue={contextMethods.setValue}
      getValues={contextMethods.getValues}
      onSubmit={contextMethods.handleSubmit(onSubmit)}
      selectedCurrency={selectedCurrency}
      slots={{
        invoiceHeaderSlot: <ConnectedAutoFillMe />,
        customerHeaderSlot: readonly ? null : <ConnectedAutoFillCustomersButton />,
        vendorHeaderSlot: readonly ? null : <ConnectedAutoFillVendorsButton />,
      }}
    />
  );
};
